import React from "react"
import { Spacer } from "../atoms/Atoms"
import Helpers from "../../../utils/Helpers"
import { BodySmall } from "../atoms/Bodies"

/**
 * A visual representation of how much a member has used in their plan
 * Note that values here (minValue, maxValue) are expected in cents
 * Add more bars to the thermometer as needed:
 *
 * bars[] {
 *    percentage
 *    value
 *    color
 *    label
 * }
 */
export const Thermometer = ({ minValue, maxValue, currencySymbol, bars, barBackgroundColor, callToAction }) => (
  <>
    <div className="flex justify-between">
      <BodySmall color="black-80">{Helpers.convertToCurrencyString(minValue, currencySymbol, 0)}</BodySmall>
      <BodySmall color="black-80">{Helpers.convertToCurrencyString(maxValue, currencySymbol, 0)}</BodySmall>
    </div>
    <Spacer height={0.5} />
    <div className="relative overflow-hidden br-pill" style={{ height: 12 }}>
      <Bar percentage="100" color={barBackgroundColor} />
      {bars.map(({ percentage, color }, index) => (
        <Bar key={index} percentage={percentage} color={color} />
      ))}
    </div>
    <Spacer height={0.5} />
    <div className="flex flex-wrap">
      {bars.map(({ color, value, label }, index) => (
        <React.Fragment key={index}>
          <Key text={label} color={color} amount={value} currencySymbol={currencySymbol} />
          <Spacer width={0.5} />
        </React.Fragment>
      ))}
      {callToAction && <div className="flex flex-auto justify-end">{callToAction}</div>}
    </div>
  </>
)

const Bar = ({ color, percentage }) => (
  <div className={`dib absolute br-pill bg-${color}`} style={{ width: percentage + "%", height: 12 }} />
)

const Key = ({ color, amount, text, currencySymbol }) => (
  <div className="flex items-center">
    <div className={`bg-${color} br-100`} style={{ height: 9, width: 9 }} />
    <Spacer width={0.25} />
    <BodySmall color="black-80">
      {Helpers.convertToCurrencyString(amount, currencySymbol, 0)}
      {" " + text}
    </BodySmall>
  </div>
)
